import React from "react";
import {
  Box,
  createStyles,
  debounce,
  FormControl,
  IconButton,
  InputAdornment,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";

import { Search as SearchIcon } from "@eroad/icons/material";

import type { SearchOption } from "./types";

const useStyles = makeStyles(() =>
  createStyles({
    root: {},
    search: {
      width: "100%",
      "& > div": {
        width: "100%",
        paddingRight: "5px",
      },
      "& > input": {
        fontSize: "14px",
        fontWeight: "500",
        color: "rgba(0, 0, 0, 0.38)",
      },
      "& button": {
        padding: 0,
      },
    },
    adornedEnd: {
      paddingRight: 0,
      "& button": {
        padding: 0,
      },
    },
    select: {
      "& svg": {
        top: "calc(50% - 14px)",
      },
    },
  }),
);

interface SearchSlimProps {
  query?: string;
  queryPlaceholderText?: string;
  options?: SearchOption[];
  selectedOption?: string;
  onChangeQuery: (query: string) => void;
  onChangeOption?: (option: string) => void;
}

const SearchSlim = ({
  query,
  queryPlaceholderText,
  options,
  selectedOption,
  onChangeQuery,
  onChangeOption,
}: SearchSlimProps): JSX.Element => {
  const classes = useStyles();
  const [search, setSearch] = React.useState<string>(query ?? "");
  const [optionSelect, setOptionSelect] = React.useState<string>(
    selectedOption || ((options && options[0].name) ?? ""),
  );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onQueryChange = React.useCallback(debounce(onChangeQuery, 500), [onChangeQuery]);
  const onQuery = (evnt: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(evnt.target.value);
    onQueryChange(evnt.target.value);
  };
  const onSelectOption = (evnt: React.ChangeEvent<{ name?: string | undefined; value: unknown }>) => {
    setOptionSelect(evnt.target.value as string);
    if (onChangeOption) onChangeOption(evnt.target.value as string);
  };
  return (
    <>
      <Box display="flex" p={4}>
        <Box flexGrow={1}>
          <TextField
            id="inspector-search"
            variant="outlined"
            placeholder={queryPlaceholderText ?? "Search"}
            size="small"
            value={search}
            onChange={onQuery}
            className={classes.search}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ paddingRight: "0px" }}>
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {options && (
          <Box pl={4} display="flex" alignItems="center" flexShrink={1} style={{ maxWidth: "40%" }}>
            <FormControl className={classes.select}>
              <Select
                labelId="fleet-label"
                id="fleet-select"
                value={optionSelect}
                onChange={onSelectOption}
                disableUnderline
              >
                {options &&
                  options.map((option) => (
                    <MenuItem key={option.name} value={option.value}>
                      {option.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
        )}
      </Box>
    </>
  );
};
export default SearchSlim;
